/**
 * @generated SignedSource<<9a390e4a23673683f1b33a3252b858b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllStudentsFilterInput = {
  anyDiagnosticRetakeAssigned?: boolean | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  lastDiagnosticCompletedFrom?: any | null | undefined;
  lastDiagnosticCompletedTo?: any | null | undefined;
  onlyWithOutstandingDiagnostic?: boolean | null | undefined;
  onlyWithResetDiagnostic?: boolean | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  studentEmailContains?: string | null | undefined;
  studentEmails?: ReadonlyArray<string> | null | undefined;
  studentNameContains?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGetStudentsCountQuery$variables = {
  filter: AllStudentsFilterInput;
  skip?: boolean | null | undefined;
};
export type DashboardGetStudentsCountQuery$data = {
  readonly allStudents?: {
    readonly totalCount: number;
  } | null | undefined;
};
export type DashboardGetStudentsCountQuery = {
  response: DashboardGetStudentsCountQuery$data;
  variables: DashboardGetStudentsCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "StudentConnection",
        "kind": "LinkedField",
        "name": "allStudents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGetStudentsCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGetStudentsCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1df2db49c199ba6064138c2ffee9fe58",
    "id": null,
    "metadata": {},
    "name": "DashboardGetStudentsCountQuery",
    "operationKind": "query",
    "text": "query DashboardGetStudentsCountQuery(\n  $filter: AllStudentsFilterInput!\n  $skip: Boolean = false\n) {\n  allStudents(filter: $filter) @skip(if: $skip) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "89a1786f4b289f20863dd947d3127624";

export default node;
